import { Controller } from "@hotwired/stimulus"

// Live-previews the selected logo file before upload, matching the
// prototype's FileReader-based preview (README Onboarding Step 1).
export default class extends Controller {
  static targets = ["input", "preview"]

  change() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.previewTarget.style.backgroundImage = `url(${URL.createObjectURL(file)})`
    this.previewTarget.style.backgroundSize = "cover"
    this.previewTarget.style.backgroundPosition = "center"
    this.previewTarget.textContent = ""
  }
}
